import { FormStep } from '../types/ContactForm';


export const createStep = (
    stepNumber: number,
    title?: string,
    description: string = ''
): FormStep => {
    return {
        id: stepNumber.toString(),
        title: title || `Schritt ${stepNumber}`,
        description
    };
};


export const removeStep = (steps: FormStep[], stepNumber: number): FormStep[] => {
    return steps
        .filter((_, index) => index !== stepNumber - 1)
        .map((step, index) => ({
            ...step,
            id: (index + 1).toString(),
            title: step.title.replace(/Schritt \d+/, `Schritt ${index + 1}`)
        }));
};


export const updateStepTitle = (steps: FormStep[], stepNumber: number, title: string): FormStep[] => {
    return steps.map((step, index) =>
        index === stepNumber - 1 ? { ...step, title } : step
    );
};


export const updateStepDescription = (
    steps: FormStep[],
    stepNumber: number,
    description: string
): FormStep[] => {
    return steps.map((step, index) =>
        index === stepNumber - 1 ? { ...step, description } : step
    );
};


export const calculateNewActiveStep = (
    currentActiveStep: number,
    removedStepNumber: number
): number => {
    if (currentActiveStep === removedStepNumber) {
        return Math.max(1, removedStepNumber - 1);
    } else if (currentActiveStep > removedStepNumber) {
        return currentActiveStep - 1;
    }
    return currentActiveStep;
};

